<template>
    <v-container>
        <p class="title mb-0">Slaapdagboek</p>
        <p class="subtitle-1">Datum: {{$route.params.date}}</p>

        <v-expansion-panels dark>
             <v-expansion-panel>
                <v-expansion-panel-header class="headline">Invulinformatie</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p>Het is belangrijk dat u dit slaapdagboek invult nadat u definitief bent wakker geworden, zodat dit u nachtrust niet verstoord.</p> 
                    <p>Het slaapdagboek dient naar <strong>eigen inzicht en beleving</strong> te worden ingevuld. Kies hiervoor een vaste plek (bv. in de keuken) en een vast tijdstip (bv. tijdens het ontbijt) uit.</p>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-alert dismissible type="success" v-if="form.saved" class="mt-3">
            De data is reeds ingediend en opgeslagen.
        </v-alert>

        <v-stepper 
        v-model="form.step" 
        vertical 
        light
        class="mt-5">
            <v-stepper-step :complete="form.step > 1" step="1">
            Slaappatroon
            <small>Wat was uw slaappatroon deze nacht?</small>
            </v-stepper-step>

            <v-stepper-content step="1">
                <v-card color="secondary" class="mb-12 " height="100%">
                    <v-form
                        class="pr-5 pl-5 pt-5 pb-5"
                        v-model="valid_form_1"
                        ref="form_1"
                        :lazy-validation="true">
                        <v-row 
                            class="d-flex justify-space-between">
                            <v-col
                                cols="12"
                                md="3">
                                <h3 class="mb-3">Hoelaat ging u naar bed?</h3>
                                <v-time-picker
                                    format="24hr"
                                    :full-width="true"
                                    v-model="form.bedTime"
                                    :rules="timeValidationRules"
                                    class="d-none d-lg-flex d-xl-flex"
                                    :disabled="form.saved">
                                </v-time-picker>
                                <v-text-field 
                                    class="d-lg-none d-xl-none"
                                    type="time" 
                                    v-model="form.bedTime"
                                    :rules="timeValidationRules"
                                    outlined
                                    label="naar bed"
                                    :disabled="form.saved" >
                                </v-text-field>
                                
                                <div class="d-sm-block d-md-none">
                                    <h3 class="mb-3">Hoelang duurde het voordat u in slaap viel? (minuten)</h3>
                                    <v-slide-group class="mb-3" :center-active="true">
                                        <v-btn-toggle dense v-model="form.timeToSleep" :disabled="form.saved">
                                            <v-slide-item>
                                                <v-btn :value="0" color="primary" active-class="dark" :disabled="form.saved">0</v-btn>
                                            </v-slide-item>
                                            <v-slide-item>
                                                <v-btn :value="5" color="primary" active-class="dark" :disabled="form.saved">5</v-btn>
                                            </v-slide-item>
                                            <v-slide-item>
                                                <v-btn :value="15" color="primary" active-class="dark" :disabled="form.saved">15</v-btn>
                                            </v-slide-item>
                                            <v-slide-item>
                                                <v-btn :value="30" color="primary" active-class="dark" :disabled="form.saved">30</v-btn>
                                            </v-slide-item>
                                            <v-slide-item>
                                                <v-btn :value="60" color="primary" active-class="dark" :disabled="form.saved">60+</v-btn>
                                            </v-slide-item>
                                        </v-btn-toggle>
                                    </v-slide-group>
                                    <v-text-field
                                        outlined
                                        class="mt-0 pt-0 text-center"
                                        type="number"
                                        label="minuten"
                                        clearable
                                        v-model="form.timeToSleep"
                                        :disabled="form.saved">
                                    </v-text-field>
                                </div>
                            </v-col>
                            
                            <v-col 
                                cols="12"
                                md="3">
                                <h3 class="mb-3">Hoelaat bent u definitief wakker geworden?</h3>
                                <v-time-picker
                                    format="24hr"
                                    :full-width="true"
                                    v-model="form.wakeUpTime"
                                    :rules="timeValidationRules"
                                    :disabled="form.saved"
                                    class="d-none d-lg-flex d-xl-flex">
                                </v-time-picker>
                                <v-text-field 
                                    class="d-lg-none d-xl-none"
                                    type="time" 
                                    v-model="form.wakeUpTime"
                                    :rules="timeValidationRules"
                                    outlined
                                    label="opstaan"
                                    :disabled="form.saved" >
                                </v-text-field>

                                <div class="d-sm-block d-md-none">
                                    <h3 class="mb-3">Hoelang na het definitief wakker worden bent u nog in bed blijven liggen? (minuten)</h3>

                                    <v-slide-group class="mb-3" :center-active="true">
                                        <v-btn-toggle dense v-model="form.timeToGetOutOfBed">
                                            <v-slide-item>
                                                <v-btn :value="0" color="primary" active-class="dark" :disabled="form.saved">0</v-btn>
                                            </v-slide-item>
                                            <v-slide-item>
                                                <v-btn :value="5" color="primary" active-class="dark" :disabled="form.saved">5</v-btn>
                                            </v-slide-item>
                                            <v-slide-item>
                                                <v-btn :value="15" color="primary" active-class="dark" :disabled="form.saved">15</v-btn>
                                            </v-slide-item>
                                            <v-slide-item>
                                                <v-btn :value="30" color="primary" active-class="dark" :disabled="form.saved">30</v-btn>
                                            </v-slide-item>
                                            <v-slide-item>
                                                <v-btn :value="60" color="primary" active-class="dark" :disabled="form.saved">60+</v-btn>
                                            </v-slide-item>
                                        </v-btn-toggle>
                                    </v-slide-group>
                                    <v-text-field
                                        outlined
                                        class="mt-0 pt-0 text-center"
                                        type="number"
                                        label="minuten"
                                        v-model="form.timeToGetOutOfBed"
                                        :disabled="form.saved">
                                    </v-text-field>
                                </div>
                            </v-col>

                            <v-col
                                cols="12"
                                md="6">
                                <div class="d-none d-md-block">
                                    <h3 class="mb-3">Hoelang duurde het voordat u in slaap viel? (minuten)</h3>
                                    <v-slider 
                                        min="0" 
                                        :max="180"
                                        class="align-center"
                                        v-model="form.timeToSleep"
                                        :disabled="form.saved">
                                        <template v-slot:append>
                                            <v-text-field
                                                outlined
                                                class="mt-0 pt-0 text-center"
                                                type="number"
                                                style="width: 65px"
                                                label="minuten"
                                                v-model="form.timeToSleep"
                                                :disabled="form.saved">
                                            </v-text-field>
                                        </template>
                                    </v-slider>
                                    <h3 class="mb-3">Hoelang na het definitief wakker worden bent u nog in bed blijven liggen? (minuten)</h3>
                                    <v-slider 
                                        min="0" 
                                        :max="180"
                                        class="align-center"
                                        v-model="form.timeToGetOutOfBed"
                                        :disabled="form.saved">
                                    <template v-slot:append>
                                        <v-text-field
                                            outlined
                                            class="mt-0 pt-0 text-center"
                                            type="number"
                                            style="width: 65px"
                                            label="minuten"
                                            v-model="form.timeToGetOutOfBed"
                                            :disabled="form.saved">
                                        </v-text-field>
                                    </template>
                                    </v-slider>
                                </div>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card>
                <v-btn color="primary" @click="next('form_1')" :disabled="!valid_form_1">Volgende</v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="form.step > 2" step="2">
                Waakjes
                <small>Hoe vaak ben je wakker geworden gedurende de nacht?</small>
            </v-stepper-step>

            <v-stepper-content step="2">
                <v-card color="secondary" class="mb-12" height="100%">
                    <v-form
                        class="pa-5"
                        ref="form_2"
                        v-model="valid_form_2">
                        <h3 class="mb-3">Hoe vaak ben je wakker geworden gedurende de nacht, zonder je laatste moment van ontwaken?</h3>
                        <v-slide-group class="mb-3" :center-active="true">
                            <v-btn-toggle dense v-model="form.numberOfWakeUps" @change="$refs['form_2'].validate()">
                                <v-slide-item>
                                    <v-btn :value="0" color="primary" active-class="dark" :disabled="form.saved">0</v-btn>
                                </v-slide-item>
                                <v-slide-item>
                                    <v-btn :value="1" color="primary" active-class="dark" :disabled="form.saved">1</v-btn>
                                </v-slide-item>
                                <v-slide-item>
                                    <v-btn :value="2" color="primary" active-class="dark" :disabled="form.saved">2</v-btn>
                                </v-slide-item>
                                <v-slide-item>
                                    <v-btn :value="3" color="primary" active-class="dark" :disabled="form.saved">3</v-btn>
                                </v-slide-item>
                                <v-slide-item>
                                    <v-btn :value="4" color="primary" active-class="dark" :disabled="form.saved">4</v-btn>
                                </v-slide-item>
                                <v-slide-item>
                                    <v-btn :value="5" color="primary" active-class="dark" :disabled="form.saved">5+</v-btn>
                                </v-slide-item>
                            </v-btn-toggle>
                        </v-slide-group>

                        <v-expansion-panels>
                            <v-expansion-panel v-for="(n, i) in form.wakeUps">
                                <v-expansion-panel-header v-slot="{ open }">
                                    <v-row no-gutters>
                                        <v-col>{{n.index}}<sup>e</sup> waakje</v-col>
                                        <v-col class="text--secondary d-none d-sm-block">
                                            <v-fade-transition leave-absolute>
                                                <span v-if="open"></span>
                                                <span v-else>{{n.time}}</span>
                                            </v-fade-transition>
                                        </v-col>
                                        <v-col class="text--secondary">
                                            <v-fade-transition leave-absolute>
                                                <span v-if="open"></span>
                                                <span v-else>{{n.duration}} min.</span>
                                            </v-fade-transition>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-text-field 
                                        v-model="n.time"
                                        type="time"
                                        outlined
                                        small
                                        :autofocus="n.index === 1"
                                        hint="Maak een schatting van het tijdstip"
                                        :disabled="form.saved"
                                        :rules="duringSleepTime"
                                        label="tijdstip">
                                    </v-text-field>

                                    <h3>Hoelang duurde het voordat uw weer in slaap viel?</h3>
                                    <v-list dark :disabled="form.saved">
                                        <v-list-item-group v-model="n.duration" :rules="minValueIsOne">
                                            <v-list-item :disabled="form.saved" :value="5">
                                                <v-list-item-content>
                                                    <v-list-item-title>Minder dan 5 minuten (&lt; 5)</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item :disabled="form.saved" :value="15">
                                                <v-list-item-content>
                                                    <v-list-item-title>Minder dan 15 minuten (&lt; 15)</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item :disabled="form.saved" :value="29">
                                                <v-list-item-content>
                                                    <v-list-item-title>Minder dan 30 minuten (&lt; 30)</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                            <v-list-item :disabled="form.saved" :value="30">
                                                <v-list-item-content>
                                                    <v-list-item-title>Meer dan 30 minuten (&gt; 30)</v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-form>
                </v-card>
                <v-btn color="primary" @click="next('form_2')"  :disabled="!valid_form_2">Volgende</v-btn>
                <v-btn text  @click="form.step--">Vorige</v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="form.step > 3" step="3">
                Algemene vragen
                <small>Vragen over de dag voorafgaand.</small>
            </v-stepper-step>

            <v-stepper-content step="3">
                <v-card color="secondary" class="mb-12 pt-5 pl-5 pr-5" height="100%">
                    <v-form
                        class="pr-0 pl-0 pl-md-5 pr-md-5 pt-5 pb-5"
                        v-model="valid_form_3"
                        ref="form_3"
                        :lazy-validation="true">
                        <v-switch v-model="form.hasNaps" class="ma-0" label="Heeft u dutjes gedaan?" :readonly="form.saved" @change="(form.hasNaps) ? form.numberOfNaps = 1 : form.numberOfNaps = 0"></v-switch>
                        <v-row v-if="form.hasNaps">
                            <v-col cols="12" lg="4">
                                <v-slider 
                                        min="1" 
                                        max="5"
                                        class="align-center"
                                        v-model="form.numberOfNaps"
                                        :rules="minValueIsOne"
                                        hide-details
                                        :disabled="form.saved">
                                    <template v-slot:append>
                                        <v-text-field
                                            outlined
                                            class="mt-0 pt-0 text-center"
                                            type="number"
                                            style="width: 65px"
                                            label="aantal"
                                            hide-details
                                            v-model="form.numberOfNaps"
                                            :rules="minValueIsOne"
                                            :disabled="form.saved">
                                        </v-text-field>
                                    </template>
                                </v-slider>
                            </v-col>
                            <v-col cols="12" lg="8">
                                <v-row v-for="i in form.naps" :key="i.index">
                                    <v-col cols="12" sm="6" class="pt-1">
                                        <h3 class="subtitle-1 d-md-none d-block">{{i.index}}<sup>e</sup> <span> dutje</span></h3>
                                        <v-text-field
                                            outlined
                                            hide-details
                                            class="text-center"
                                            type="time"
                                            :rules="timeValidationRules"
                                            label="tijd"
                                            v-model="i.time"
                                            :disabled="form.saved">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pt-1">
                                        <h3 class="subtitle-1 d-md-none d-block">Duur dutje</h3>
                                        <v-text-field
                                            outlined
                                            hide-details
                                            class="text-center"
                                            type="number"
                                            label="minuten"
                                            :rules="minValueIsOne"
                                            v-model="i.duration"
                                            :disabled="form.saved">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-switch v-model="form.hasAlcohol" class="ma-0" label="Heeft u alcohol gedronken?" :readonly="form.saved"></v-switch>
                        <v-row v-if="form.hasAlcohol">
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    outlined
                                    class="text-center"
                                    type="number"
                                    label="hoeveel"
                                    hide-details
                                    v-model="form.numberOfAlcohol"
                                    :rules="minValueIsOne"
                                    :disabled="form.saved">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    outlined
                                    class="text-center"
                                    type="time"
                                    :rules="timeValidationRules"
                                    hide-details
                                    label="laatste"
                                    v-model="form.timeOfLastAlcohol"
                                    :disabled="form.saved">
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-switch v-model="form.hasCafeine" class="ma-0" label="Heeft u cafeïnehoudende dranken gedronken? (koffie, (ijs-)thee, energiedrankjes, cola, chocolade en chocolademelk)" :readonly="form.saved"></v-switch>
                        <v-row v-if="form.hasCafeine">
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    outlined
                                    class="text-center"
                                    type="number"
                                    label="hoeveel"
                                    hide-details
                                    v-model="form.numberOfCafeine"
                                    :rules="minValueIsOne"
                                    :disabled="form.saved">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    outlined
                                    class="text-center"
                                    type="time"
                                    :rules="timeValidationRules"
                                    label="laatste"
                                    hide-details
                                    v-model="form.timeOfLastCafeine"
                                    :disabled="form.saved">
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-switch v-model="form.hasSleepingDrug" class="ma-0" label="Heeft u een slaapmiddel gebruikt?" :readonly="form.saved"></v-switch>
                        <v-row v-if="form.hasSleepingDrug">
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    outlined
                                    class="text-center"
                                    type="number"
                                    label="aantal"
                                    hide-details
                                    v-model="form.numberOfSleepingDrug"
                                    :rules="minValueIsOne"
                                    :disabled="form.saved">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    outlined
                                    class="text-center"
                                    type="time"
                                    :rules="timeValidationRules"
                                    label="tijd"
                                    hide-details
                                    v-model="form.timeOfLastSleepingDrug"
                                    :disabled="form.saved">
                                </v-text-field>
                            </v-col>
                            
                            <v-col cols="12">
                                <v-text-field
                                    outlined
                                    class="text-center"
                                    type="text"
                                    hide-details
                                    label="naam slaapmiddel"
                                    v-model="form.descriptionOfSleepingDrug"
                                    :disabled="form.saved">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card>
                <v-btn color="primary" @click="next('form_3')" :disabled="!valid_form_3">Volgende</v-btn>
                <v-btn text @click="form.step--">Vorige</v-btn>
            </v-stepper-content>

            <v-stepper-step step="4">Algehele beoordeling
                <small>Wat is uw algehele beoordeling over uw nachtrust deze nacht?</small>
            </v-stepper-step>
            <v-stepper-content step="4">
                <v-card color="secondary" class="mb-12 pt-12 pb-12 text-center" height="100%">
                    <v-form
                        class="pr-0 pl-0 pl-md-5 pr-md-5 pt-5 pb-5"
                        v-model="valid_form_4"
                        ref="form_4"
                        :lazy-validation="true">
                        <p>Was je slaap rustig of onrustig?</p>
                        <v-rating length="5" 
                        x-large dense 
                        v-model="form.sleepRating"
                        :readonly="form.saved">
                        </v-rating>
                        <div class="d-flex justify-space-between pl-5 pr-5 mb-5">
                            <div><small>onrustig</small></div>
                            <div><small>rustig</small></div>
                        </div>
                        
                        <p class="mt-8">Voelde je je uitgeslapen?</p>
                        <v-rating length="5" 
                        x-large dense 
                        v-model="form.restRating"
                        :readonly="form.saved">
                        </v-rating>
                        <div class="d-flex justify-space-between pl-5 pr-5 mb-5">
                            <div><small>--</small></div>
                            <div><small>++</small></div>
                        </div>

                        <p class="mt-8">Hoe is je stemming nu?</p>
                        <v-rating length="5" 
                        x-large dense 
                        v-model="form.moodRating"
                        :readonly="form.saved">
                        </v-rating>
                        <div class="d-flex justify-space-between pl-5 pr-5 mb-5">
                            <div><small>slecht</small></div>
                            <div><small>goed</small></div>
                        </div>
                    </v-form>
                </v-card>
                <v-btn color="primary" class="mb-5" @click="complete('form_4')" v-if="!form.saved" :disabled="!valid_form_1 || !valid_form_2 || !valid_form_3 || !valid_form_4">Voltooien</v-btn>
                <v-btn color="primary" class="mb-5" :to="{ name: 'report' }" v-else>Naar Rapport</v-btn>
                <v-btn text @click="form.step--" class="mb-5">Vorige</v-btn>
                <v-btn text @click="saveForm(null)" class="mb-5" v-if="!form.saved">Concept Opslaan</v-btn>
            </v-stepper-content>
        </v-stepper>
    </v-container>
</template>

<script>
  export default {
    data () {
      return {
        range: [0, 20],
        valid_form_1: false,
        valid_form_2: false,
        valid_form_3: false,
        valid_form_4: false,
        timeValidationRules: [
            v => !!v || 'Verplicht',
            v => !!v && v.indexOf(":") == 2 || 'Ongeldige tijd.'
        ],
        wakupTimeRules: [
            v => !!v || 'Verplicht',
        ],
        minValueIsOne: [
            v => parseInt(v) > 0 || 'Minimale waarde is 1.'
        ],
        duringSleepTime: [
            v => !!v || 'Verplicht',
            v => !!v && v.indexOf(":") == 2 || 'Ongeldige tijd.',
            v => {
                if(v == null)
                    return true;

                let bedTime = this.form.bedTime.match(/^(\d+):(\d+)$/);
                let wakeUpTime = this.form.wakeUpTime.match(/^(\d+):(\d+)$/);
                let value = v.match(/^(\d+):(\d+)$/);

                bedTime = +bedTime[1] * 60 + +bedTime[2];
                wakeUpTime = +wakeUpTime[1] * 60 + +wakeUpTime[2];
                value = +value[1] * 60 + +value[2];

                return value > bedTime || value < wakeUpTime || 'Tijd moet gedurende de bedtijd liggen.';
            }
        ],
        storage: [],
        form: {
            id: 0,
            date: this.$route.params.date,
            step: 1,
            saved: false,
            savedToCloud: false,
            bedTime: "22:00",
            timeToSleep: 0,
            wakeUpTime: "07:00",
            timeToGetOutOfBed: 0,
            numberOfWakeUps: 0,
            wakeUps: [],
            hasNaps: false,
            numberOfNaps: 0,
            naps: [],
            hasAlcolhol: false,
            numberOfAlcohol: 1,
            timeOfLastAlcolhol: null,
            hasCafeine: false,
            numberOfCafeine: 1,
            timeOfLastCafeine: null,
            hasSleepingDrug: false,
            numberOfSleepingDrug: 1,
            timeOfLastSleepingDrug: null,
            descriptionOfSleepingDrug: null,
            sleepRating: 3,
            restRating: 3,
            moodRating: 3
        }
      }
    },
    mounted() {
        if(!this.$route.params.date)
            return this.$router.back();

        let storage = localStorage.getItem(this.yearMonth);
        if(!!storage)
        {
            this.storage = JSON.parse(storage);

            let form = this.storage.find((c) => c.date == this.$route.params.date);
            if(!!form)
                this.form = form;
        };
    },
    methods: {
        toggleWakeUpTimes(num) {
            if(num > this.form.numberOfWakeUps)
            {
                for(let i = 0; i < num - this.form.numberOfWakeUps; i++)
                {
                    this.form.wakeUps.push({
                        index: this.form.wakeUps.length + 1,
                        minutes: 30,
                        time: (parseInt(this.form.bedTime.split(":")[0], 10) + 1) + ":00",
                        description: null
                    });
                }
            } else {
                for(let i = 0; i < this.form.numberOfWakeUps - num; i++)
                {
                    this.form.wakeUps.pop();
                }
            }

            this.form.numberOfWakeUps = num;
        },
        next(form) {
            if(this.$refs[form].validate()) {
                this.saveForm(null).then(() => {
                    this.form.step++;
                });
            }
        },
        complete(form) {
            if(this.$refs[form].validate()) {
                this.saveForm(true).then(() => {
                    this.$store.dispatch("SAVE_TO_CLOUD", this.form);
                });
            };
        },
        saveForm(save) {
            return new Promise((resolve, reject) => {
                if(this.form.saved)
                    return resolve();

                if(save)
                    this.form.saved = true;

                let form = this.storage.find((c) => c.date == this.$route.params.date);
                if(!!form)
                    this.storage.splice(this.storage.indexOf(form), 1);

                this.storage.push(this.form);
                this.storage = this.storage.sort(function(a, b) { return a.date - b.date; });

                localStorage.setItem(this.yearMonth, JSON.stringify(this.storage));
                return resolve();
            });
        }
    },
    computed: {
        numberOfWakeUps() {
            return this.form.numberOfWakeUps;
        },
        numberOfNaps() {
            return this.form.numberOfNaps;
        },
        yearMonth() {
            return this.$route.params.date.substring(0, 7);
        },
        maxWakeTime() {
            let bedTime = new Date(this.form.date + " " + this.form.bedTime),
             wakeUpTime = new Date(new Date(this.form.date + " " + this.form.wakeUpTime).setDate(bedTime.getDate() + 1)),
                wakedUp = this.form.wakeUps.reduce((a, b) => a + (b.minutes || 0), 0);
            
            if(this.form.bedTime.split(":")[0] < 17)
                bedTime = new Date(bedTime.setDate(bedTime.getDate() + 1));

            let totalSleepTime =  (wakeUpTime - bedTime) / 3600000 * 60
            return (totalSleepTime - wakedUp);
        }
    },
    watch: {
        numberOfWakeUps: {
            handler(to, from) {
                if(this.form.wakeUps.length != to)
                {
                    if(to > from)
                    {
                        for(let i = 0; i < to - from; i++)
                        {
                            this.form.wakeUps.push({
                                index: this.form.wakeUps.length + 1,
                                duration: 30,
                                time: (parseInt(this.form.bedTime.split(":")[0], 10) + 1) + ":00",
                                description: null
                            });
                        }
                    } else {
                        for(let i = 0; i < from - to; i++)
                        {
                            this.form.wakeUps.pop();
                        }
                    }
                }
            }
        },
        numberOfNaps: {
            handler(to, from) {
                if(this.form.naps.length != to)
                {
                    if(to > from)
                    {
                        for(let i = 0; i < to - from; i++)
                        {
                            this.form.naps.push({
                                index: this.form.naps.length + 1,
                                time: this.form.wakeUpTime,
                                duration: 1
                            });
                        }
                    } else {
                        for(let i = 0; i < from - to; i++)
                        {
                            this.form.naps.pop();
                        }
                    }
                }
            }
        }
    }
  }
</script>

<style scoped lang="scss">
.list-primary {
    background-color: red;
}

@media only screen and (max-width: 425px) {
    .container {
        padding-left: 5px;
        padding-right: 5px;
    }
    .v-stepper--vertical .v-stepper__content,
    .v-stepper--vertical .v-stepper__step {
        padding-left: 5px;
        padding-right: 41px;
    }
}
.v-stepper--vertical {
    padding-bottom: 0px;
}

</style>